import { CALL_API } from '../middleware/api';

export const TYPES = {
  PRICETRACKER_REQUEST: 'PRICETRACKER_REQUEST',
  PRICETRACKER_SUCCESS: 'PRICETRACKER_SUCCESS',
  PRICETRACKER_FAILURE: 'PRICETRACKER_FAILURE',
  PRICETRACKER_SET_FULL_NAME: 'PRICETRACKER_SET_FULL_NAME',
  PRICETRACKER_SET_EMAIL: 'PRICETRACKER_SET_EMAIL',
  PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION: 'PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION',
};

export function postSignUp(formData = {}, endpoint) {
  return {
    [CALL_API]: {
      types: [
        TYPES.PRICETRACKER_REQUEST,
        TYPES.PRICETRACKER_SUCCESS,
        TYPES.PRICETRACKER_FAILURE,
      ],
      endpoint,
      requestOptions: {
        method: 'POST',
        formData,
      },
    },
  };
}

export const setFullName = payload => ({
  type: TYPES.PRICETRACKER_SET_FULL_NAME,
  payload,
});

export const setEmail = payload => ({
  type: TYPES.PRICETRACKER_SET_EMAIL,
  payload,
});

export const setNewsletterSubscription = payload => ({
  type: TYPES.PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION,
  payload,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/priceTrackerActions.js
 **/